var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2671 0H23.7338V40H16.2671V0Z",
    fill: "#44C1C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5015 3.21777L36.7812 8.4975L8.49692 36.7818L3.21719 31.502L31.5015 3.21777Z",
    fill: "#44C1C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 16.2671V23.7338H0V16.2671H40Z",
    fill: "#44C1C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7822 31.5039L31.5025 36.7836L3.21823 8.49937L8.49796 3.21964L36.7822 31.5039Z",
    fill: "#44C1C2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53255 3.20068L3.19922 8.53402L14.6659 20.0007L3.19922 31.4673L8.53255 36.8007L25.3326 20.0007L8.53255 3.20068Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkIcon);
export default __webpack_public_path__ + "static/media/spark-icon.be2c08398de15d70a286a23efc289b91.svg";
export { ForwardRef as ReactComponent };